import SrEditTable from "./index.vue";

SrEditTable.install = function(Vue) {
  Vue.component(SrEditTable.name, SrEditTable);
};

export default SrEditTable;



// WEBPACK FOOTER //
// ./packages/SrEditTable/index.js